import React from "react";
import NoContent from "../components/commons/NoContent";

export const NotFound = () => {
  return <NoContent></NoContent>;
};
